













































import { Type, ListType, ListOptions, isNumber, Expression, ListOps, Exprs } from 'expangine-runtime';
import { SimpleFieldSettings, friendlyList } from '../../../common';
import { TypeUpdateEvent } from '../TypeVisuals';
import { ListSubs } from './ListTypes';
import TypeEditorBase from '../TypeEditorBase';


const fields: SimpleFieldSettings<ListOptions> = [
  { name: 'min', type: 'number', label: 'Min' },
  { name: 'max', type: 'number', label: 'Max' },
];

export default TypeEditorBase<ListType, any, ListSubs>().extend({
  name: 'ListEditor',
  computed: {
    optionFields: () => fields,
    description(): string {
      const { min, max } = this.type.options;
      const things: string[] = [];

      if (isNumber(min) && isNumber(max)) {
        things.push('between ' + min + ' and ' + max + ' items');
      } else if (isNumber(min)) {
        things.push('at least ' + min + ' items');
      } else if (isNumber(max)) {
        things.push('no more than ' + max + ' items');
      }

      return friendlyList(things);
    },
    requiredItem() {
      return this.requiredType && this.requiredType instanceof ListType
        ? this.requiredType.options.item
        : null;
    },
  },
  methods: {
    onChange(event: TypeUpdateEvent) {
      this.type.options.item = event.type;
      this.settings.sub.item = event.settings;

      const transform = event.transform
        ? this.type.getValueChangeExpression(event.transform, ListType.STEP_ITEM, ListType.STEP_ITEM)
        : undefined;

      this.change({ transform });
    },
  },
});
